import {
    CommitmentObservationLinkDto,
    NoteDetails,
} from '../../../coaching-base/general';
import { createAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';

export interface AddCommitmentNotes {
    performerId: number;
    coachId: number;
    notes: NoteDetails[];
    willNavigate?: boolean;
}

export const addCommitmentNotes = createAction<ActionType, AddCommitmentNotes>(
    ActionType.COACHING_DETAIL__TD__ADD_COMMITMENT_NOTES,
);

export interface AddCommitmentNotesResult extends AddCommitmentNotes {
    commitmentInfo: CommitmentObservationLinkDto[];
}

export const addCommitmentNotesResult = createAction<
    ActionType,
    AddCommitmentNotesResult
>(ActionType.COACHING_DETAIL__TD__ADD_COMMITMENT_NOTES_RESULT);
